<template>
  <div class="main-layout predicted-xlcs-page predicted-item-page">
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="心理测试"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <div class="form-container">
            <el-form
              ref="form"
              :model="handleData"
              label-position="top"
              v-if="this.titleData.length"
            >
              <el-form-item
                :label="index + 1 + '、' + item.name"
                v-for="(item, index) in titleData"
                :key="item.id"
              >
                <el-radio-group v-model="handleData[item.id]">
                  <el-radio
                    :label="option.optionId + ',' + option.score"
                    :disabled="resultData.length > 0"
                    v-for="option in item.options"
                    :key="option.optionId"
                    >{{ option.optionName }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item class="btn-item">
                <el-button
                  type="primary"
                  @click="onSubmit"
                  :disabled="isSubmit || resultData.length > 0"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      handleData: {},
      titleData: [],
      resultData: [],
      isSubmit: false,
      forecastLinkId: "",
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.forecastLinkId = this.$route.params.id;
  },
  mounted() {
    this.getTitleData();
    this.getMyTest();
  },
  methods: {
    //查询迎新心理测试题目
    getTitleData() {
      this.$http
        .get("/welcome-forecast/psytest/template/getTitleOfWelcome")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.titleData = res.data;
          } else {
            this.$message.error(`${res.msg}`);
          }
        });
    },
    //查询心理测试结果
    getMyTest() {
      this.$http
        .get("/welcome-forecast/psytest/result/myTestOfWelcome")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.resultData = res.data;
            if (this.resultData.length) {
              this.resultData.forEach((item) => {
                this.handleData[item.titleId] =
                  item.optionId + "," + item.score;
              });
            }
          }
        });
    },
    onSubmit() {
      if (!this.forecastLinkId) {
        // 提示无事项id
        this.$message.error("请重新进入页面后重试！");
        // 跳转到预报到事项列表页
        this.$router.push("/welcome/student/predicted");
        return;
      }
      console.log(this.handleData);
      let resultData = [];
      for (let key in this.handleData) {
        resultData.push({
          titleId: key,
          optionId: this.handleData[key].split(",")[0],
          score: this.handleData[key].split(",")[1],
        });
      }
      if (resultData.length < this.titleData.length) {
        this.$message.error("请完成后提交");
        return;
      }
      this.$confirm("提交后不能修改, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = resultData;
          this.isSubmit = true;
          console.log(params);
          this.$http
            .post(
              "/welcome-forecast/psytest/result/saveWelcome?forecastLinkId=" +
                this.forecastLinkId,
              params
            )
            .then((res) => {
              console.log(res);
              if (res.code == this.SUCCESS_CODE) {
                this.$message.success(`${res.msg}`);
                this.$router.go(-1);
              } else {
                this.$message.error(`${res.msg}`);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>
